import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconPencilOutline = ({ color = 'currentColor', size = 'medium', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" size={size} {...props}>
        <StyledStrokedGroup color={color}>
            <StyledPath
                color="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.642 1.358a2.73 2.73 0 00-3.877.026L1.89 12.259.563 17.437 5.74 16.11 16.616 5.234a2.729 2.729 0 00.026-3.876v0zm-4.187.337l3.85 3.85M1.89 12.258l3.855 3.848"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
